var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleBed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1032_9034",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#paint0_linear_1032_9034)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1032_9034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5867 18.2609H15.7906C15.4699 15.6039 15.9895 14.3733 17.4118 14.3693C19.2049 14.3653 20.9966 14.368 22.7896 14.3693C24.3174 14.3693 24.7681 15.3157 24.5867 18.2609Z",
    fill: "url(#paint1_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87355 24.7155C2.87355 23.8441 2.8316 23.017 2.88302 22.1966C2.98045 20.6228 4.31476 19.4002 5.9522 19.3908C9.154 19.3734 12.3558 19.3841 15.5563 19.3841C21.3509 19.3841 27.1455 19.3841 32.9388 19.3841C35.2217 19.3841 36.4261 20.5893 36.4289 22.8668C36.4289 23.4674 36.4289 24.0666 36.4289 24.7141H2.87355V24.7155Z",
    fill: "url(#paint2_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88672 28.1102V25.8809H36.3852V28.1102H2.88672Z",
    fill: "url(#paint3_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 32.9369V29.2598H5.59878C5.30377 30.5145 5.02229 31.7143 4.7354 32.9369H2.90039Z",
    fill: "url(#paint4_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5585 32.9397C34.2703 31.7104 33.9915 30.5254 33.6992 29.2773H36.3841V32.9397H34.5585Z",
    fill: "url(#paint5_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7188 13.015C33.6538 9.93311 31.0542 7.23326 27.9404 7.19305C22.4381 7.122 16.9344 7.13004 11.432 7.19171C8.62945 7.22388 6.05421 9.46392 5.76326 12.2174C5.5535 14.2014 5.72266 16.2243 5.72266 18.2605H8.02319C7.85945 18.2605 7.69435 18.2605 7.53061 18.2605C6.87293 15.7336 8.32903 14.6786 12.3834 14.6773C13.2007 14.6773 14.0181 14.6773 14.8355 14.6773C15.1576 13.8006 15.7746 13.3783 16.7016 13.377C18.9304 13.3716 21.1592 13.3743 23.388 13.377C24.4382 13.377 25.0783 13.7376 25.403 14.6786C26.1825 14.6786 26.9633 14.6786 27.7428 14.6786C31.9866 14.6786 33.2885 15.5674 32.7864 18.2632H31.019C31.019 18.2632 31.019 18.2726 31.019 18.278H33.7242C33.7242 16.4964 33.754 14.7564 33.7174 13.0177L33.7188 13.015ZM30.812 13.7604C30.2761 13.8448 30.2274 13.4453 30.1719 13.0351C29.9757 11.59 28.9296 10.6785 27.4492 10.6771C22.2635 10.6691 17.0792 10.6677 11.8935 10.6771C10.4144 10.6798 9.39133 11.6061 9.21 13.0646C9.16263 13.4493 9.08685 13.8113 8.59697 13.7697C8.09085 13.7268 8.11386 13.33 8.13145 12.9601C8.21941 11.1664 9.82437 9.63551 11.7203 9.61406C14.3808 9.58591 17.0399 9.60736 19.7004 9.60736V9.60468C22.3149 9.60468 24.9308 9.59127 27.5452 9.6087C29.4669 9.62211 30.992 10.9787 31.2396 12.8582C31.2911 13.2442 31.3317 13.6786 30.8106 13.7604H30.812Z",
    fill: "url(#paint6_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0201 17.5297C30.9741 16.2897 30.043 15.2803 28.8061 15.2562C27.7208 15.2347 26.6342 15.2253 25.5475 15.2267C25.6855 15.9559 25.7031 16.9345 25.6246 18.2188H20.3104C20.3104 18.2322 20.3104 18.2456 20.3104 18.259H18.7934C18.7934 18.2456 18.7921 18.2322 18.7907 18.2188H14.6849C14.5347 16.9788 14.5334 15.9868 14.6809 15.2334C13.2234 15.224 11.7646 15.2294 10.3072 15.2508C9.06487 15.2696 8.11082 16.2334 8.02421 17.4708C8.00662 17.7147 8.02151 17.96 8.02151 18.2603H31.0174C31.0174 17.9989 31.0241 17.763 31.0174 17.5297H31.0201Z",
    fill: "url(#paint7_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7943 18.259H20.3113C20.3113 18.2442 20.3113 18.2322 20.3113 18.2188H18.793C18.793 18.2322 18.7943 18.2456 18.7957 18.259H18.7943Z",
    fill: "url(#paint8_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02589 17.4734C8.1125 16.2361 9.06519 15.2722 10.3088 15.2534C11.7663 15.232 13.2237 15.2266 14.6826 15.236C14.7232 15.0336 14.7746 14.8486 14.8355 14.6797C14.0181 14.6797 13.2007 14.6797 12.3834 14.6797C8.32902 14.681 6.87292 15.7374 7.5306 18.263H8.02319C8.02319 17.9627 8.0083 17.7174 8.02589 17.4734Z",
    fill: "url(#paint9_linear_1032_9034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7441 14.6771C26.9646 14.6771 26.1838 14.6771 25.4043 14.6771C25.4611 14.842 25.5085 15.0257 25.5477 15.2267C26.6344 15.2267 27.7197 15.2348 28.8064 15.2562C30.0446 15.2804 30.9756 16.2898 31.0203 17.5298C31.0284 17.7644 31.0217 17.999 31.0203 18.2604H32.7877C33.2897 15.5646 31.9879 14.6771 27.7441 14.6758V14.6771Z",
    fill: "url(#paint10_linear_1032_9034)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1032_9034",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1032_9034",
    x1: 20.1619,
    y1: 14.3672,
    x2: 20.1619,
    y2: 18.2609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1032_9034",
    x1: 19.6431,
    y1: 19.3809,
    x2: 19.6431,
    y2: 24.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1032_9034",
    x1: 19.636,
    y1: 25.8809,
    x2: 19.636,
    y2: 28.1102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1032_9034",
    x1: 4.24959,
    y1: 29.2598,
    x2: 4.24959,
    y2: 32.9369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1032_9034",
    x1: 35.0416,
    y1: 29.2773,
    x2: 35.0416,
    y2: 32.9397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1032_9034",
    x1: 19.6969,
    y1: 7.14258,
    x2: 19.6969,
    y2: 18.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1032_9034",
    x1: 19.518,
    y1: 15.2266,
    x2: 19.518,
    y2: 18.2603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1032_9034",
    x1: 19.5521,
    y1: 18.2188,
    x2: 19.5521,
    y2: 18.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1032_9034",
    x1: 11.1072,
    y1: 14.6797,
    x2: 11.1072,
    y2: 18.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1032_9034",
    x1: 29.1469,
    y1: 14.6758,
    x2: 29.1469,
    y2: 18.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBed);
export default __webpack_public_path__ + "static/media/single_bed.93a82837183f6742e5828bb3e00278f0.svg";
export { ForwardRef as ReactComponent };